import { z } from 'zod';
import { zColor, zId, zIdioma, zRol, zSlug } from './comunes.js';
export const zLoginBody = z.object({
    username: z.string().min(1).max(120).trim(),
    password: z.string().min(1).max(200),
    /**
     * Sólo para el segundo paso cuando el mismo usuario existe en más de una empresa
     * (D2). El login normal NO pide empresa: un selector público revelaría la cartera
     * de clientes de la plataforma.
     */
    empresaSlug: zSlug.optional(),
});
export const zTokens = z.object({
    accessToken: z.string(),
    /** Sólo se devuelve a clientes no-web (móvil). En web viaja en cookie httpOnly. */
    refreshToken: z.string().optional(),
    expiresIn: z.number().int().positive(),
});
export const zLoginResp = z.object({
    accessToken: z.string().optional(),
    refreshToken: z.string().optional(),
    expiresIn: z.number().int().positive().optional(),
    debeCambiarPassword: z.boolean().optional(),
    /**
     * Presente SÓLO cuando las credenciales son válidas en más de una cuenta (D2):
     * lista las empresas de ESE usuario para que elija. Nunca lista otras.
     */
    elegirEmpresa: z
        .array(z.object({ slug: z.string(), nombre: z.string() }))
        .optional(),
});
export const zRefreshBody = z.object({
    refreshToken: z.string().optional(),
    plataforma: z.enum(['web', 'ios', 'android']).default('web'),
});
export const zCambiarPasswordBody = z.object({
    passwordActual: z.string().min(1).max(200),
    passwordNueva: z.string().min(8).max(200),
});
export const zForgotPasswordBody = z.object({
    username: z.string().min(1).max(120).trim(),
});
export const zResetPasswordBody = z.object({
    token: z.string().min(10),
    passwordNueva: z.string().min(8).max(200),
});
export const zBrandingPublico = z.object({
    nombreVisible: z.string().nullable(),
    logoUrl: z.string().nullable(),
    logoOscuroUrl: z.string().nullable(),
    faviconUrl: z.string().nullable(),
    colorPrimario: zColor,
    colorAcento: zColor,
    colorFondo: zColor,
    modoOscuro: z.boolean(),
    idiomaPorDefecto: zIdioma,
});
export const zMarcaResumen = z.object({
    id: zId,
    nombre: z.string(),
    slug: z.string(),
    logoUrl: z.string().nullable(),
    colorPrimario: z.string().nullable(),
    colorSecundario: z.string().nullable(),
});
export const zMeResp = z.object({
    usuario: z.object({
        id: zId,
        username: z.string(),
        email: z.string().nullable(),
        rol: zRol,
        idioma: zIdioma,
        debeCambiarPassword: z.boolean(),
    }),
    empresa: z
        .object({ id: zId, slug: z.string(), nombre: z.string() })
        .nullable(),
    cliente: z
        .object({
        id: zId,
        razonSocial: z.string(),
        nombreNegocio: z.string().nullable(),
        ruc: z.string(),
        ciudad: z.string().nullable(),
    })
        .nullable(),
    marcas: z.array(zMarcaResumen),
    branding: zBrandingPublico,
    /** El vendedor no ve costos (D13); el front oculta la columna con esta bandera. */
    puedeVerCosto: z.boolean(),
});
export const zEmpresaPublica = z.object({
    slug: z.string(),
    nombre: z.string(),
    nombreVisible: z.string().nullable(),
    logoUrl: z.string().nullable(),
    colorPrimario: zColor,
    colorAcento: zColor,
});
//# sourceMappingURL=auth.js.map